'use client'

import { useCallback } from 'react'
import { useBetActions } from 'src/store/bet'
import { useGetPlayerChannel } from 'src/store/socket'
import { promisifyPush } from 'src/utils/promisifyPush'
import { BetMap } from 'src/types/mappers/BetMap'
import type { BetDTO } from 'src/actions/types'

export function usePlayerBets() {
  const playerChannel = useGetPlayerChannel()
  const betActions = useBetActions()

  const fetchBets = useCallback(async () => {
    if (!playerChannel || playerChannel.state !== 'joined') {
      console.warn('Cannot fetch bets. Player channel not ready, state:', playerChannel?.state || 'undefined')
      // Don't capture exception for temporary unavailability - this is expected during reconnections
      return
    }

    try {
      const result = await promisifyPush({
        channel: playerChannel,
        eventName: 'client:player:bets:get'
      })

      const responseDTO = result as BetDTO[]
      const domainBets = responseDTO.map(BetMap.fromBetDTO)

      betActions.setBets(domainBets)
    } catch (error) {
      console.error('Fetching player bets failed:', error)
    }
  }, [playerChannel, betActions])

  return { fetchBets }
}
